import { DisableCalendarDates } from '../../core/components/calendar/CalendarTypes'
import { Palette } from '../../themes/useTheme'

export type FilterBarTypes = {
  language?: string
  ageCategories?: AgeCategoryType[]
  redirectUrl?: string
  palette?: Palette
  onSubmit?: ((val: Filters) => void) | null
  fullWidth?: boolean
  disableCalendarDates?: DisableCalendarDates
  mode?: string
  tabs?: Tab[]
  outerLoading?: boolean
  locations?: Locations
}

export type AgeCategoryCount = {
  [categoryId: string]: number
}

export type AgeCategoryType = {
  id: string
  name: string
  minVal: number
  sortOrder: number
}

export type GuestsCountPropsType = {
  label: string
  id: string
  updateGuestsCount: (arg1: string, arg2: number) => void
  count: number
  minVal: number
  sortOrder: number
}

export enum FilterSections {
  CALENDAR = 'calendar',
  GUESTS = 'guests',
  LOCATIONS = 'locations',
}

export type Filters = { [key: string]: string }

export enum Pages {
  ROOMS = '/rooms',
  EVENTS = '/events',
  SALES = '/sales',
}

export type Tab = {
  path: string
  default?: boolean
  order: number
  label?: string
}

export type Locations = {
  multiSelect?: boolean
  disabled?: boolean
  data: Location[]
}

export type Location = {
  id: number
  label: string
  description?: string | null
  imageUrl?: string | null
}
